import React, { useContext, useEffect, useState } from 'react';
import { Card, Spinner, Button, Form, Nav, ListGroup, Badge } from 'react-bootstrap';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useToken from 'hooks/useToken';
import AppContext from 'context/Context';
import VacationDetailsModal from './VacationDetailsModal';
import PropTypes from 'prop-types';
import './TeamVacationsCalendar.css';

const TeamVacationsCalendar = ({
    diasDisponibles = 0,
    onSelectionSubmit,
    saving = false,
    soloCalendario = false,
    idUsuarioSeleccionado = null //Para saber qué empleado estamos consultando
}) => {
    const { config: { isDark } } = useContext(AppContext);
    const { token } = useToken();
    const jsonToken = decodeJWT(token);
    const idUsuarioToken = jsonToken?.idUsuario;
    const idUsuarioDestino = idUsuarioSeleccionado || idUsuarioToken;

    console.log("idUsuario inicio sesion", idUsuarioToken);
    console.log("idUsuario empleado seleccionado:", idUsuarioDestino);
    const [showModal, setShowModal] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [vacations, setVacations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [fechasBloqueadas, setFechasBloqueadas] = useState(new Set());
    const [activeTab, setActiveTab] = useState('rango');
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedDaysList, setSelectedDaysList] = useState([]);
    const [motivo, setMotivo] = useState('');
    const [rangeInput, setRangeInput] = useState({ startDate: '', endDate: '' });

    const puedeEditar = String(idUsuarioToken) === String(idUsuarioDestino);
    const puedeInteractuar = diasDisponibles > 0 && !saving && puedeEditar;

    useEffect(() => {
        loadTeamVacations();
    }, [token, idUsuarioSeleccionado]); // Recargar si cambia el token o el empleado en vista

    function decodeJWT(token) {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                window.atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error("Token inválido o mal formado", error);
            return null;
        }
    }

    const getColorByStatus = (estado) => {
        const estadoUpper = estado?.toUpperCase();
        if (estadoUpper === 'APROBADA') {
            return { bg: '#00D176'}; //success
        }
        return { bg: '#FD7E14'}; //warning
    };

    const createLocalDate = (dateString) => {
        const [year, month, day] = dateString.split('-').map(Number);
        return new Date(year, month - 1, day);
    };

    const formatLocalDateToString = (date) => {
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    const loadTeamVacations = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch('/api/vacaciones/ObtenerVacacionesEquipo', {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error(`Error ${response.status}`);
            const data = await response.json();

            if (data.iResponseType === 1 && data.detalles) {
                const detalles = JSON.parse(data.detalles);
                const vacacionesData = detalles.table2 || detalles.table1 || [];

                const eventos = [];
                const diasOcupadosPorUnUsuario = new Set();

                console.log("Datos planos recibidos:", vacacionesData);

                const solicitudesAgrupadas = vacacionesData.reduce((acc, current) => {
                    const idSolicitud = current.idVacacion || current.idSolicitudVacaciones;
                    if (!acc[idSolicitud]) {
                        acc[idSolicitud] = {
                            ...current,
                            idSolicitudVacaciones: idSolicitud,
                            listaFechas: []
                        };
                    }
                    if (current.dFechaVacaciones) {
                        const fechaLimpia = current.dFechaVacaciones.split('T')[0];
                        acc[idSolicitud].listaFechas.push(fechaLimpia);
                    }
                    return acc;
                }, {});

                //Eventos individuales para FullCalendar
                Object.values(solicitudesAgrupadas).forEach(vac => {
                    vac.listaFechas.sort();

                    const colors = getColorByStatus(vac.vEstado);
                    const fotoUrl = vac.vFoto ? `data:image/jpeg;base64,${vac.vFoto}` : '/images/profiles/default-profile.png';

                    const commonProps = {
                        idVacacion: vac.idSolicitudVacaciones,
                        idUsuario: vac.idUsuario,
                        nombreCompleto: vac.vNombreCompleto || vac.vNombre,
                        puesto: vac.vPuesto || 'No especificado',
                        departamento: vac.vDepartamento || 'No especificado',
                        foto: fotoUrl,
                        diasSolicitados: vac.listaFechas.length,
                        estado: vac.vEstado,
                        comentarios: vac.vComentarios || '',
                        categoria: vac.vCategoria || 'Vacaciones',
                        vMotivoSolicitud: vac.vMotivoSolicitud || '',
                        fechaInicioOriginal: vac.listaFechas[0],
                        fechaFinOriginal: vac.listaFechas[vac.listaFechas.length - 1],
                        vFechasJson: JSON.stringify(vac.listaFechas),
                        dCreatedDate: vac.dCreatedDate,
                        vUpdatedUser: vac.vUpdatedUser,
                        vUsuarioAprobador: vac.vUsuarioAprobador,
                        //vPuestoUsuarioAprobador: vac.vPuestoUsuarioAprobador

                    };

                    vac.listaFechas.forEach(fecha => {
                        if (String(idUsuarioDestino) === String(vac.idUsuario)) {
                            diasOcupadosPorUnUsuario.add(fecha);
                        }

                        eventos.push({
                            id: `${vac.idSolicitudVacaciones}-${fecha}`,
                            title: vac.vNombreCompleto || vac.vNombre,
                            start: fecha,
                            end: fecha,
                            allDay: true,
                            display: 'auto',
                            backgroundColor: colors.bg,
                            borderColor: colors.border,
                            textColor: colors.text,
                            extendedProps: {
                                ...commonProps,
                                fechaExplicit: fecha,
                                totalFechasEspecificas: vac.listaFechas.length
                            }
                        });
                    });
                });

                setFechasBloqueadas(diasOcupadosPorUnUsuario);
                setVacations(eventos);
            }
        } catch (err) {
            console.error(err);
            setError('Error al cargar el calendario del equipo.');
        } finally {
            setLoading(false);
        }
    };

    const construirObjetoDia = (dateStr) => {
        const localDate = createLocalDate(dateStr);
        return {
            date: new Date(localDate),
            dateString: dateStr,
            dayName: localDate.toLocaleDateString('es-MX', { weekday: 'long' }),
            dayNumber: localDate.getDate(),
            month: localDate.toLocaleDateString('es-MX', { month: 'long' }),
            year: localDate.getFullYear()
        };
    };

    const generarFechasRango = (startStr, endStr) => {
        let arr = [];
        let dt = createLocalDate(startStr);
        const end = createLocalDate(endStr);

        while (dt <= end) {
            const day = dt.getDay();
            if (day !== 0) {
                arr.push(formatLocalDateToString(dt));
            }
            dt.setDate(dt.getDate() + 1);
        }
        return arr;
    };

    const handleDateSelect = (selectInfo) => {
        const fechaSeleccionada = selectInfo.startStr;
        const fechaLocal = createLocalDate(fechaSeleccionada);
        const diaSemana = fechaLocal.getDay();

        if (diaSemana === 0) {
            selectInfo.view.calendar.unselect();
            return;
        }

        if (activeTab === 'especificos') {
            if (fechasBloqueadas.has(fechaSeleccionada)) {
                selectInfo.view.calendar.unselect();
                return;
            }

            setSelectedDates((prev) => {
                let nuevasFechas;
                if (prev.includes(fechaSeleccionada)) {
                    nuevasFechas = prev.filter(d => d !== fechaSeleccionada);
                } else {
                    if (prev.length >= diasDisponibles) return prev;
                    nuevasFechas = [...prev, fechaSeleccionada];
                }
                const listaEstructurada = nuevasFechas.sort().map(f => construirObjetoDia(f));
                setSelectedDaysList(listaEstructurada);
                return nuevasFechas;
            });
        } else {
            if (!rangeInput.startDate || (rangeInput.startDate && rangeInput.endDate)) {
                setRangeInput({ startDate: fechaSeleccionada, endDate: '' });
                setSelectedDates([fechaSeleccionada]);
                setSelectedDaysList([construirObjetoDia(fechaSeleccionada)]);
            } else {
                const inicio = rangeInput.startDate;
                const fin = fechaSeleccionada;

                if (createLocalDate(fin) < createLocalDate(inicio)) {
                    if (fechasBloqueadas.has(fin)) {
                        selectInfo.view.calendar.unselect();
                        return;
                    }
                    setRangeInput({ startDate: fin, endDate: '' });
                    setSelectedDates([fin]);
                    setSelectedDaysList([construirObjetoDia(fin)]);
                } else {
                    let fechasRango = generarFechasRango(inicio, fin);
                    const fechasDisponiblesRango = fechasRango.filter(fecha => !fechasBloqueadas.has(fecha));

                    if (fechasDisponiblesRango.length === 0) {
                        selectInfo.view.calendar.unselect();
                        return;
                    }

                    let seleccionFinal = fechasDisponiblesRango;
                    if (seleccionFinal.length > diasDisponibles) {
                        seleccionFinal = seleccionFinal.slice(0, diasDisponibles);
                    }

                    setSelectedDates(seleccionFinal);
                    setSelectedDaysList(seleccionFinal.sort().map(f => construirObjetoDia(f)));

                    if (seleccionFinal.length > 0) {
                        setRangeInput({
                            startDate: inicio,
                            endDate: seleccionFinal[seleccionFinal.length - 1]
                        });
                    }
                }
            }
        }
        selectInfo.view.calendar.unselect();
    };

    const handleInputChange = (e) => {
        if (activeTab === 'especificos') return;
        const { name, value } = e.target;
        const nuevoRango = { ...rangeInput, [name]: value };
        setRangeInput(nuevoRango);

        if (nuevoRango.startDate && nuevoRango.endDate) {
            if (createLocalDate(nuevoRango.endDate) >= createLocalDate(nuevoRango.startDate)) {
                const fechas = generarFechasRango(nuevoRango.startDate, nuevoRango.endDate);
                const fechasValidas = fechas.filter(fecha => !fechasBloqueadas.has(fecha));
                const seleccionFinal = fechasValidas.slice(0, diasDisponibles);

                setSelectedDates(seleccionFinal);
                setSelectedDaysList(seleccionFinal.sort().map(f => construirObjetoDia(f)));
            } else {
                setRangeInput({ startDate: nuevoRango.startDate, endDate: '' });
                setSelectedDates([nuevoRango.startDate]);
                setSelectedDaysList([construirObjetoDia(nuevoRango.startDate)]);
            }
        } else if (nuevoRango.startDate) {
            if (!fechasBloqueadas.has(nuevoRango.startDate)) {
                setSelectedDates([nuevoRango.startDate]);
                setSelectedDaysList([construirObjetoDia(nuevoRango.startDate)]);
            } else {
                setSelectedDates([]);
                setSelectedDaysList([]);
            }
        } else {
            setSelectedDates([]);
            setSelectedDaysList([]);
        }
    };

    const removeDayFromList = (dateString) => {
        if (activeTab === 'rango') {
            const fechaLocal = createLocalDate(dateString);

            if (fechaLocal.getDay() === 6) {
                const nuevasFechas = selectedDates.filter(d => d !== dateString);
                const fechasOrdenadas = [...nuevasFechas].sort();
                setSelectedDates(nuevasFechas);
                setSelectedDaysList(fechasOrdenadas.map(f => construirObjetoDia(f)));
            } else {
                setRangeInput({ startDate: '', endDate: '' });
                setSelectedDates([]);
                setSelectedDaysList([]);
            }
        } else {
            const nuevasFechas = selectedDates.filter(d => d !== dateString);
            const fechasOrdenadas = [...nuevasFechas].sort();

            setSelectedDates(nuevasFechas);
            setSelectedDaysList(fechasOrdenadas.map(f => construirObjetoDia(f)));
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setSelectedDates([]);
        setSelectedDaysList([]);
        setRangeInput({ startDate: '', endDate: '' });
    };

    const handleCancelar = () => {
        setSelectedDates([]);
        setSelectedDaysList([]);
        setRangeInput({ startDate: '', endDate: '' });
        setMotivo('');
    };

    const handleEnviarSolicitud = async () => {
        if (selectedDates.length === 0 || !onSelectionSubmit) return;

        const success = await onSelectionSubmit(selectedDates, motivo);
        if (success) {
            handleCancelar();
            loadTeamVacations();
        }
    };

    const handleEventClick = (clickInfo) => {
        const event = clickInfo.event;
        if (event.extendedProps.isManualSelection) {
            removeDayFromList(event.startStr);
            return;
        }

        const {
            idVacacion,
            idUsuario,
            nombreCompleto,
            puesto,
            foto,
            departamento,
            categoria,
            diasSolicitados,
            estado,
            comentarios,
            fechaInicioOriginal,
            fechaFinOriginal,
            dCreatedDate,
            vMotivoSolicitud,
            vFechasJson,
            vUsuarioAprobador
        } = event.extendedProps;

        console.log("Datos del evento extendido:", event.extendedProps);
        setSelectedEmployee({
            idVacacion: idVacacion || event.id,
            idUsuario,
            name: nombreCompleto,
            position: puesto,
            photo: foto,
            department: departamento,
            categoria,
            vacationStart: fechaInicioOriginal,
            vacationEnd: fechaFinOriginal,
            dCreatedDate,
            daysRequested: diasSolicitados,
            estado, comentarios,
            fechaExplicit: event.extendedProps.fechaExplicit,
            totalFechasEspecificas: event.extendedProps.totalFechasEspecificas,
            vFechasJson,
            vUsuarioAprobador,
            //vPuestoUsuarioAprobador,
            vMotivoSolicitud,


        });
        setShowModal(true);
    };

    const formatDisplayDate = (day) => {
        const opciones = { weekday: 'long', day: '2-digit', month: 'short', year: 'numeric' };
        let formatted = day.date.toLocaleDateString('es-MX', opciones);
        formatted = formatted.replace('.', '');
        return formatted.replace(/(^\w|\s\w)/g, (match) => match.toUpperCase());
    };

    const formatearFecha = (dateString) => {
        if (!dateString) return '';
        const dateObj = createLocalDate(dateString);
        const opciones = { day: '2-digit', month: 'short', year: 'numeric' };
        let formatted = dateObj.toLocaleDateString('es-MX', opciones);
        formatted = formatted.replace('.', '');
        return formatted.replace(/[a-z]+/, (match) => match.charAt(0).toUpperCase() + match.slice(1));
    };

    const fechaOcupada = (selectInfo) => {
        const fechaString = selectInfo.startStr;
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        const fechaCelda = createLocalDate(fechaString);

        if (fechaCelda < hoy || fechasBloqueadas.has(fechaString)) {
            return false;
        }
        return true;
    };

    if (loading) {
        return (
            <Card className="p-4 pt-5">
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-2 text-muted">Sincronizando vistas...</p>
                </div>
            </Card>
        );
    }

    if (error) {
        return (
            <Card className="p-4 pt-5">
                <div className="alert alert-danger">{error}</div>
            </Card>
        );
    }

    if (soloCalendario) {
        return (
            <Card className="p-4 border-0 shadow-sm rounded-3">
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                    <h3 className="fw-bold mb-1 text-1000">Vacaciones del equipo</h3>
                    <div className="d-flex gap-3 align-items-center">
                        <small><span className="badge me-1 bg-success">■</span> Aprobadas</small>
                        <small><span className="badge me-1 bg-warning">■</span> Pendientes</small>
                    </div>
                </div>

                <div className={`vacation-calendar-wrapper ${isDark ? 'calendar-dark-mode' : ''}`}>
                    <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        headerToolbar={{ left: 'prev', center: 'title', right: 'next' }}
                        locale="es"
                        height="auto"
                        fixedWeekCount={false}
                        showNonCurrentDates={false}
                        dayMaxEvents={3}
                        eventClick={handleEventClick}
                        selectable={false}
                        events={vacations}
                        dayCellClassNames={(arg) => {
                            const fString = arg.date.toISOString().split('T')[0];
                            const hoy = new Date();
                            hoy.setHours(0, 0, 0, 0);
                            const fechaCelda = createLocalDate(fString);

                            if (fechaCelda < hoy || fechasBloqueadas.has(fString)) {
                                return isDark
                                    ? 'bg-1000 fc-cell-disabled pointer-events-none'
                                    : 'bg-100 fc-cell-disabled pointer-events-none';
                            }
                            return isDark ? 'bg-100 text-white' : '';
                        }}
                    />
                </div>

                <VacationDetailsModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    employee={selectedEmployee}
                    onSuccess={loadTeamVacations}
                    showActions={true}
                />
            </Card>
        );
    }

    return (
        <Card className="p-4 pt-5">
            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-1">
                <div>
                    <h3 className="fw-bold mb-1 text-1000">Solicitar Vacaciones</h3>
                    <p className="text-900 mb-0 small font-sans-serif">Planifica tu próximo descanso con facilidad.</p>
                </div>
                <div
                    className="d-flex align-items-center p-2 px-3 rounded-3"
                    style={{
                        backgroundColor: isDark ? '#1e293b' : '#eef5ff',
                        border: isDark ? '1px solid #334155' : '1px solid #d4e5ff',
                        minWidth: '180px'
                    }}
                >
                    <div className="balance-icon-wrapper d-flex align-items-center justify-content-start" style={{ width: '35px', height: '35px' }}>
                        <FontAwesomeIcon icon="calendar-check" size="lg" className="text-success" />
                    </div>
                    <div>
            
                        <strong className={"text-dark"} style={{ fontSize: '1rem', fontWeight: '700' }}>
                            {diasDisponibles} Días disponibles
                        </strong>
                    </div>
                </div>
            </div>

            <div className="row g-4 mt-1">
                <div className={`col-12 ${puedeEditar ? 'col-xl-8' : 'col-xl-12'}`}>
                    <Card className="border-0 shadow-sm rounded-3">
                        <Card.Body className="p-4">
                            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">

                                {puedeEditar && (
                                    <>
                                        <Nav variant="pills" className={`${isDark ? 'bg-10' : 'bg-light'} p-1 rounded-2 nav-pills-custom`}>
                                            <Nav.Item>
                                                <Nav.Link
                                                    active={activeTab === 'rango'}
                                                    onClick={() => handleTabChange('rango')}
                                                    className={`fw-semibold ${activeTab === 'rango' ? 'text-white' : (isDark ? 'text-1000' : 'text-black')}`}
                                                >
                                                    Rango de fechas
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link
                                                    active={activeTab === 'especificos'}
                                                    onClick={() => handleTabChange('especificos')}
                                                    className={`fw-semibold ${activeTab === 'especificos' ? 'text-white' : (isDark ? 'text-1000' : 'text-black')}`}
                                                >
                                                    Días específicos
                                                </Nav.Link>
                                            </Nav.Item>
                                        </Nav>

                                    </>
                                )}
                               
                                <div className="d-flex gap-3 align-items-center">
                                    <small><span className="badge me-1 bg-success">■</span> Aprobadas</small>
                                    <small><span className="badge me-1 bg-warning">■</span> Pendientes</small>
                                    <small><span className="badge me-1 bg-primary">■</span> Tu Selección</small>
                                </div>
                            </div>

                            <div className={`vacation-calendar-wrapper ${isDark ? 'calendar-dark-mode' : ''}`}>
                                <FullCalendar
                                    plugins={[dayGridPlugin, interactionPlugin]}
                                    initialView="dayGridMonth"
                                    headerToolbar={{ left: 'prev', center: 'title', right: 'next' }}
                                    locale="es"
                                    height="auto"
                                    fixedWeekCount={false}
                                    showNonCurrentDates={false}
                                    dayMaxEvents={3}
                                    eventClick={handleEventClick}
                                    selectable={puedeInteractuar}
                                    selectMirror={puedeInteractuar}
                                    select={puedeInteractuar ? handleDateSelect : null}
                                    selectAllow={fechaOcupada}
                                    dayCellClassNames={(arg) => {
                                        const fString = arg.date.toISOString().split('T')[0];
                                        const hoy = new Date();
                                        hoy.setHours(0, 0, 0, 0);
                                        const fechaCelda = createLocalDate(fString);

                                        if (fechaCelda < hoy || fechasBloqueadas.has(fString)) {
                                            return isDark
                                                ? 'bg-1000 opacity-25 fc-cell-disabled text-900 pointer-events-none'
                                                : 'bg-200 opacity-25 fc-cell-disabled text-900 pointer-events-none';
                                        }

                                    }}
                                    events={[
                                        ...vacations,
                                        ...selectedDates.map((fecha) => ({
                                            id: `manual-${fecha}`,
                                            title: 'SELECCIONADO',
                                            start: fecha,
                                            end: fecha,
                                            allDay: true,
                                            display: 'auto',
                                            backgroundColor: '#0d6efd',
                                            extendedProps: { isManualSelection: true }
                                        }))
                                    ]}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </div>
                {puedeEditar && (

                    <Card className="col-12 col-xl-4">
                        <Card className="border-200 shadow-none rounded-3">
                            <Card.Body className="p-4">
                                <h5 className="fw-bold mb-4 text-900">
                                    {activeTab === 'rango' ? 'Detalles del Período' : `Días a solicitar (${selectedDates.length})`}
                                </h5>

                                {activeTab === 'rango' && (
                                    <Form className="d-flex flex-column gap-3 mb-4">
                                        <Form.Group className="position-relative">
                                            <Form.Label className="small fw-semibold text-muted mb-1" style={{ fontSize: '1rem' }}>Desde</Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="date"
                                                    name="startDate"
                                                    value={rangeInput.startDate}
                                                    onChange={handleInputChange}
                                                    disabled={!puedeInteractuar}
                                                    className={rangeInput.startDate ? "text-transparent" : ""}
                                                />
                                                {rangeInput.startDate && (
                                                    <div className="position-absolute top-50 translate-middle-y fw-medium ps-0"
                                                        style={{ zIndex: 1, pointerEvents: 'none', left: '12px', right: '35px', backgroundColor: isDark ? '#121824' : '#fff', color: isDark ? '#fff' : '#000' }}>
                                                        {formatearFecha(rangeInput.startDate)}
                                                    </div>
                                                )}
                                            </div>
                                        </Form.Group>

                                        <Form.Group className="position-relative">
                                            <Form.Label className="small fw-semibold text-muted mb-1" style={{ fontSize: '1rem' }}>Hasta</Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="date"
                                                    name="endDate"
                                                    min={rangeInput.startDate}
                                                    value={rangeInput.endDate}
                                                    onChange={handleInputChange}
                                                    disabled={!rangeInput.startDate || !puedeInteractuar}
                                                    className={rangeInput.endDate ? "text-transparent" : ""}
                                                />
                                                {rangeInput.endDate && (
                                                    <div className="position-absolute top-50 translate-middle-y fw-medium ps-0"
                                                        style={{ zIndex: 1, pointerEvents: 'none', left: '12px', right: '35px', backgroundColor: isDark ? '#121824' : '#fff', color: isDark ? '#fff' : '#000' }}>
                                                        {formatearFecha(rangeInput.endDate)}
                                                    </div>
                                                )}
                                            </div>
                                        </Form.Group>
                                    </Form>
                                )}

                                <Card className="p-3 border-0 shadow-none rounded-3 my-4" style={{ backgroundColor: isDark ? 'rgba(13, 110, 253, 0.08)' : 'rgba(13, 110, 253, 0.04)', border: isDark ? '1px solid rgba(13, 110, 253, 0.2)' : '1px solid rgba(13, 110, 253, 0.1)' }}>
                                    <Card.Body className="p-0">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="text-900 fw-medium" style={{ fontSize: '1rem' }}>Días solicitados:</span>
                                            <span className="fw-bold text-primary" style={{ fontSize: '1rem' }}>
                                                {selectedDates.length} días
                                            </span>
                                        </div>

                                        {selectedDaysList.length > 0 && (
                                            <div
                                                className="border rounded-3 my-3"
                                                style={{
                                                    maxHeight: '190px',
                                                    overflowY: 'auto',
                                                    scrollbarWidth: 'thin',
                                                    backgroundColor: isDark ? '#121824' : '#fff'
                                                }}
                                            >
                                                <ListGroup variant="flush">
                                                    {selectedDaysList.map((day, index) => {
                                                        const esSabado = day.date.getDay() === 6;
                                                        const mostrarBotonEliminar = activeTab === 'especificos' || (activeTab === 'rango' && esSabado);
                                                        return (
                                                            <ListGroup.Item key={day.dateString} className="d-flex justify-content-between align-items-center py-2 px-3 bg-transparent">
                                                                <div className="d-flex align-items-center">
                                                                    <Badge bg="success" text="white" className="me-2" style={{ minWidth: '24px' }}>
                                                                        {index + 1}
                                                                    </Badge>
                                                                    <span className="small text-700" style={{ fontSize: '0.82rem' }}>{formatDisplayDate(day)}</span>
                                                                </div>
                                                                {mostrarBotonEliminar ? (
                                                                    <Button
                                                                        variant="link"
                                                                        size="sm"
                                                                        className="text-danger p-0"
                                                                        onClick={() => removeDayFromList(day.dateString)}
                                                                    >
                                                                        <FontAwesomeIcon icon="trash-alt" />
                                                                    </Button>
                                                                ) : (
                                                                    <div style={{ width: '14px' }}></div>
                                                                )}
                                                            </ListGroup.Item>
                                                        );
                                                    })}
                                                </ListGroup>
                                            </div>
                                        )}

                                        <div className="d-flex justify-content-between align-items-center border-top pt-2 mt-2">
                                            <span className="text-900 fw-medium" style={{ fontSize: '1rem' }}>Balance restante:</span>
                                            <span className={`fw-bold ${diasDisponibles - selectedDates.length === 0 ? 'text-danger' : 'text-success'}`} style={{ fontSize: '1rem' }}>
                                                {diasDisponibles - selectedDates.length} días
                                            </span>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Form.Group className="mb-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold text-900 mb-2" style={{ fontSize: '1rem' }}>
                                            Motivo <span className="text-muted fw-normal small">(opcional)</span>
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            placeholder="Explica el motivo..."
                                            value={motivo}
                                            onChange={(e) => setMotivo(e.target.value)}
                                            disabled={!puedeInteractuar}
                                            style={{ resize: 'none', fontSize: '0.9rem' }}
                                        />
                                    </Form.Group>
                                </Form.Group>

                                <div className="d-flex flex-column gap-2 w-100">
                                    <Button
                                        variant="primary"
                                        size="lg"
                                        className="py-2.5 rounded-3 fw-semibold text-white border-0"
                                        disabled={selectedDates.length === 0 || saving || diasDisponibles === 0}
                                        onClick={handleEnviarSolicitud}
                                        style={{ backgroundColor: '#004fc4' }}
                                    >
                                        {saving ? <><Spinner size="sm" className="me-2" />Procesando...</> : 'Enviar Solicitud'}
                                    </Button>
                                    <Button
                                        variant="outline-secondary"
                                        size="lg"
                                        className="py-2 rounded-3 bg-danger border-200 text-white"
                                        onClick={handleCancelar}
                                        disabled={saving}
                                        type="button"
                                    >
                                        Cancelar
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Card>
                )}
                
            </div>

            <VacationDetailsModal
                show={showModal}
                onHide={() => setShowModal(false)}
                employee={selectedEmployee}
                onSuccess={loadTeamVacations}
                showActions={true}
            />
        </Card>
    );
};

TeamVacationsCalendar.propTypes = {
    diasDisponibles: PropTypes.number,
    onSelectionSubmit: PropTypes.func,
    saving: PropTypes.bool,
    soloCalendario: PropTypes.bool,
    idUsuarioSeleccionado: PropTypes.number
};

export default TeamVacationsCalendar;